module.exports = __webpack_public_path__ + "static/img/ID.04cec146.png";